import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { handleKeyPressSpace } from "../../common/CommonFunctions";
import CustomBreadcrumb from "../../common/CustomBreadcrumb";
import { BreadCrum } from "../../common";
import { useDispatch, useSelector } from "react-redux";
import { getProductFeaturesHandler } from "../../redux/action/getproductFeaturesSlice";
import Loader from "../Loder/loader";
import uploadimg from "../../assets/uploadicon.svg";
import eye from "../../assets/viewPdfEyeIcon.svg";
import deleteicon from "../../assets/deleteicon.svg";
import { Checkbox, message, Switch, Upload } from "antd";
import { ThemeContext } from "../../common/themeContext";
import axios from "axios";
import { API_URL } from "../../services/http";
import { fileUploadAction } from "../../redux/action/fileUpload";
import { getProductFeatureContentHandler } from "../../redux/action/getProductFeatureContentSlice";
import {
  addProductFeatureAction,
  addProductFeaturesHandler,
} from "../../redux/action/addProductFeaturesSlice";
import { useCommonMessage } from "../../common/CommonMessage";
import VisibilityModal from "./VisibilityModal";
import {
  dpcExtraDiscountValidation,
  dpcExtraDiscountValidationSpanish,
} from "../../common/Validations";
import { getItem } from "../../common/localStorage";
import { getProductParentRoute } from "../product/productNavigation";
import { useAdminPermissions } from "../../hooks/useAdminPermissions";
import DpcExtraViewOnly from "./DpcExtraViewOnly";

const EditDpcDiscount = () => {
  const [fileUploaded, setFileUploaded] = useState("");
  const [manageSwitch, setManageSwitch] = useState(false);
  const [spanishFileUpload, setSpanishFileUpload] = useState("");
  const messageApi = useCommonMessage();
  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState(null);
  const [showVisibilityModal, setShowVisibilityModal] = useState(false);
  const [activeStatus, setActiveStatus] = useState(false);

  const { Dragger } = Upload;
  const fileUploadDataSelector = useSelector((state) => state?.fileUploadData);
  const getAdminLoginId = getItem("adminId");
  const getProductId = getItem("productId");
  const refFeatureId = getItem("refFeatureId");

  const { brandId } = useContext(ThemeContext);
  const { state } = useLocation();
  const fileUploadSelector = useSelector((state) => state?.fileUploadData);
  const getProductFeatureContentSelector = useSelector(
    (state) => state?.getProductFeatureContentMain
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { hasProductViewOnly } = useAdminPermissions();
  const isViewOnly = hasProductViewOnly;
  const getProductFeaturesSelector = useSelector(
    (state) => state?.getProductFeatures
  );
  const addProductFeaturesSelector = useSelector(
    (state) => state?.addProductFeatures
  );

  const props = {
    name: "file",
    multiple: false,
    accept: ".pdf",
    showUploadList: false,
    async beforeUpload(file) {
      const isPDF = file.type === "application/pdf";
      if (!isPDF) {
        message.error("You can only upload PDF files!");
      setFileUploaded("");
        return false;
      }
      const isSizeAccepted = file.size / 1024 / 1024 < 11;
      if (!isSizeAccepted) {
        message.error("File size exceeds 10MB limit!");
        setFileUploaded("");
        return false;
      }
      if (isPDF && isSizeAccepted) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("id", Number(getAdminLoginId));
        formData.append("brandId", brandId);
        formData.append(
          "path",
          `${
            "product/" +
            getProductFeatureContentSelector?.data?.data?.productCode
          }/${getItem("featureName")}/${state?.name}/${
            state?.manageSwitch === false || manageSwitch === false
              ? "English"
              : "Spanish"
          }`
        );
        formData.append("module", "product");
        setLoading(true);
        axios
          .post(API_URL + "/file/upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          })
          .then((response) => {
            dispatch(fileUploadAction.fileUploadInfoSuccess(response.data));
            if (state?.manageSwitch === false || manageSwitch === false) {
              setFileUploaded(file?.name);
            } else {
              setSpanishFileUpload(file?.name);
            }
          })
          .catch((error) => {
            dispatch(fileUploadAction.fileUploadInfoFailure(error));
          })
          .finally(() => {
            setLoading(false);
          });
        if (state?.manageSwitch === false || manageSwitch === false) {
          setFileUploaded(file?.name);
        } else {
          setSpanishFileUpload(file?.name);
        }
      }
      return false;
    },
  };

  const getProductFeatureFunction = () => {
    if (Number(refFeatureId)) {
      let payload = {
        productId: Number(getProductId),
        refFeatureId: Number(refFeatureId),
      };
      dispatch(getProductFeaturesHandler(payload));
      dispatch(getProductFeatureContentHandler(payload));
    }
  };

  useEffect(() => {
    getProductFeatureFunction();
  }, [state]);

  useEffect(() => {
    if (isViewOnly) {
      setManageSwitch(
        state?.language === "es" || state?.language === "spanish",
      );
      return;
    }

    setManageSwitch(false);
  }, [state?.name, isViewOnly, state?.language]);

  const handleFormSubmit = (values) => {
    const isEnglish = state?.manageSwitch === false || manageSwitch === false;
    const isSpanish = !isEnglish;

    const productId = Number(getProductId);
    const featureId = Number(refFeatureId);

    const existingComponents =
      getProductFeatureContentSelector?.data?.data?.content?.componants || [];
    const existingComponentIndex = existingComponents.findIndex(
      (component) => component.name === state?.name
    );
    const updatedComponent = {
      name: state?.name,
      english: isEnglish
        ? {
            url: values?.discountUrlEnglish || "",
            phone: values?.phoneNumberEnglish?.toString() || "",
            fileUrl:
              fileUploadSelector?.data?.data?.signedUrl ||
              filteredData?.english?.fileUrl ||
              "",
            filePreSigned:
              fileUploadSelector?.data?.data?.preSignedUrl ||
              filteredData?.english?.filePreSigned ||
              "",
            fileName: fileUploaded || filteredData?.english?.fileName || "",
            isValuePresent:
              state?.manageSwitch || manageSwitch === false ? true : false,
            isVirtualCare: values?.isVirtualCareEnglish,
            virtualCare: filteredData?.english?.virtualCare ||state?.english?.virtualCare,
          }
        : filteredData?.english || {
            url: state?.english?.url || "",
            phone: state?.english?.phone || "",
            fileUrl: state?.english?.fileUrl || "",
            filePreSigned: state?.english?.filePreSigned || "",
            fileName: state?.english?.fileName || "",
            isValuePresent: state?.english?.isValuePresent || false,
            isVirtualCare: values?.isVirtualCareEnglish,
            virtualCare: state?.english?.virtualCare,
          }, // Retain or set default for English data
      spanish: isSpanish
        ? {
            url: values?.discountUrlSpanish || "",
            phone: values?.phoneNumberSpanish?.toString() || "",
            fileUrl:
              fileUploadSelector?.data?.data?.signedUrl ||
              filteredData?.spanish?.fileUrl ||
              "",
            filePreSigned:
              fileUploadSelector?.data?.data?.preSignedUrl ||
              filteredData?.spanish?.filePreSigned ||
              "",
            fileName:
              spanishFileUpload || filteredData?.spanish?.fileName || "",
            isValuePresent:
              state?.manageSwitch === true || manageSwitch === true
                ? true
                : filteredData?.spanish?.isValuePresent ||
                  state?.spanish?.isValuePresent,
            isVirtualCare: values?.isVirtualCareSpanish,
            virtualCare: filteredData?.spanish?.virtualCare ||state?.spanish?.virtualCare,
          }
        : {
            url: state?.spanish?.url || "",
            phone: state?.spanish?.phone || "",
            fileUrl:
              state?.manageSwitch === true || manageSwitch === true
                ? fileUploadSelector?.data?.data?.signedUrl
                : state?.spanish?.fileUrl,
            filePreSigned:
              state?.manageSwitch === true || manageSwitch === true
                ? fileUploadSelector?.data?.data?.preSignedUrl
                : state?.spanish?.filePreSigned,
            fileName: spanishFileUpload || state?.spanish?.fileName || "",
            isValuePresent:
              state?.manageSwitch === true || manageSwitch === true
                ? true
                : filteredData?.spanish?.isValuePresent ||
                  state?.spanish?.isValuePresent,
            isVirtualCare: values?.isVirtualCareSpanish,
            virtualCare: state?.spanish?.virtualCare,
          }, // Blank Spanish data if English PDF is set
      status: activeStatus === true ? "ACTIVE" : "INACTIVE",
      isSelected: true,
      language: state?.manageSwitch === false ? "en" : "es", 
      spanishName:state?.spanishName
    };
    let components = [...existingComponents];
    if (existingComponentIndex >= 0) {
      components[existingComponentIndex] = {
        ...existingComponents[existingComponentIndex],
        ...updatedComponent,
      };
    } else {
      components.push(updatedComponent);
    }

    // Prepare the final payload
    const payload = {
      productId,
      featureId,
      content: {
        type: getProductFeatureContentSelector?.data?.data?.content?.type,
        componants: components, // All components, including updated/new
      },
    };

    // Dispatch the payload to the API handler
    dispatch(addProductFeaturesHandler(payload, { skipForbiddenRedirect: true }));
  };

  const handleEnglishSwitch = (resetForm) => {
    setManageSwitch(false);
    getProductFeatureFunction();
    resetForm();
    setSpanishFileUpload("");
  };

  const handleSpanishSwitch = (resetForm) => {
    setManageSwitch(true);
    getProductFeatureFunction();
    resetForm();
    setFileUploaded("");
  };

  const handleDeleteFile = () => {
    const isEnglish = state?.manageSwitch === false || manageSwitch === false;
    const isSpanish = !isEnglish;

    const existingComponents =
      getProductFeatureContentSelector?.data?.data?.content?.componants || [];

    const components = existingComponents.map((element) => {
      if (element?.name === state?.name) {
        return {
          ...element,
          english: isEnglish
            ? {
                ...element.english,
                fileUrl: "",
                filePreSigned: "",
                fileName: "",
                isValuePresent: true,
                isVirtualCare:element?.english?.isVirtualCare,
                virtualCare: element?.english?.virtualCare
              }
            : element.english, 
          spanish: isSpanish
            ? {
                ...element.spanish,
                fileUrl: "",
                filePreSigned: "",
                fileName: "",
                isValuePresent: true,
                isVirtualCare:element?.spanish?.isVirtualCare,
                virtualCare:element?.spanish?.virtualCare,
              }
            : element.spanish,
        };
      }
      return element; // Keep other components unchanged
    });

    const payload = {
      productId: Number(getProductId),
      featureId: Number(refFeatureId),
      content: {
        type: getProductFeatureContentSelector?.data?.data?.content?.type,
        componants: components, // Updated components array after deletion
      },
    };
    // dispatch(addProductFeaturesHandler(payload));
    setFilteredData(payload);
    if (isEnglish) {
      setFileUploaded("");
    } else if (isSpanish) {
      setSpanishFileUpload("");
    }
    dispatch(fileUploadAction.fileUploadInfoReset());
  };

  useEffect(() => {
    if (addProductFeaturesSelector?.data?.statusCode === 200) {
      messageApi.open({
        type: "success",
        content: addProductFeaturesSelector?.data?.message,
      });
      getProductFeatureFunction();
      dispatch(fileUploadAction.fileUploadInfoReset());
      dispatch(addProductFeatureAction.addProductFeaturesInfoReset());
      navigate("/dpc-extra");
    } else if (addProductFeaturesSelector?.statusCode === 405) {
      messageApi.open({
        type: "warning",
        content:
          addProductFeaturesSelector?.message ||
          "You don't have permission to access this page.",
      });
      dispatch(addProductFeatureAction.addProductFeaturesInfoReset());
      navigate("/dpc-extra", { replace: true });
    } else if (addProductFeaturesSelector?.message) {
      messageApi.open({
        type: "error",
        content: addProductFeaturesSelector?.message,
      });
      dispatch(addProductFeatureAction.addProductFeaturesInfoReset());
    }
  }, [addProductFeaturesSelector, dispatch, manageSwitch, messageApi, navigate, state]);

  useEffect(() => {
    const data =
      getProductFeatureContentSelector?.data?.data?.content?.componants?.find(
        (item) => item?.name === state?.name
      );

    if (data) {
      setFilteredData(data);
    }
  }, [
    getProductFeatureContentSelector?.data?.data?.content?.componants,
    state?.name,
  ]);

  useEffect(() => {
    if (filteredData?.status === "ACTIVE") {
      setActiveStatus(true);
    } else if (filteredData?.status === "INACTIVE") {
      setActiveStatus(false);
    }
  }, [filteredData]);

  const handleSwitchChange = () => {
    setShowVisibilityModal(true);
  };

  const componentData = filteredData || state;
  const viewLangData = manageSwitch
    ? componentData?.spanish || state?.spanish
    : componentData?.english || state?.english;

  return (
    <>
      {(getProductFeaturesSelector?.isLoading === true ||
        addProductFeaturesSelector?.isLoading === true ||
        fileUploadDataSelector?.isLoading === true ||
        getProductFeatureContentSelector?.isLoading === true ||
        loading) && <Loader loaderTransForm="loaderTransForm" />}
      <div className="rightside">
        <div className="rightcontent">
          <p>
            <strong>{isViewOnly ? "Manage Product" : "Products"}</strong>
          </p>
          <CustomBreadcrumb
            items={[
              { text: BreadCrum.HOME },
              {
                text: BreadCrum.PRODUCTS,
                onClick: () => navigate("/product"),
              },
              {
                text: BreadCrum.MANAGE_PRODUCTS,
                onClick: () =>
                  navigate(getProductParentRoute(state || {}), {
                    state: state?.productData,
                  }),
              },
              {
                text: BreadCrum.DPC_EXTRA_LIST,
                onClick: () => navigate("/dpc-extra", { state: state }),
              },
              {
                text: state?.name,
                active: true,
              },
            ]}
          />
          {isViewOnly ? (
            <DpcExtraViewOnly
              componentName={state?.name}
              manageSwitch={manageSwitch}
              onEnglishSwitch={() => setManageSwitch(false)}
              onSpanishSwitch={() => setManageSwitch(true)}
              activeStatus={activeStatus}
              url={viewLangData?.url || ""}
              phone={viewLangData?.phone || ""}
              fileName={viewLangData?.fileName || ""}
              fileUrl={viewLangData?.fileUrl || viewLangData?.filePreSigned || ""}
              isTelemedicine={state?.name === "Telemedicine"}
              isVirtualCare={Boolean(viewLangData?.isVirtualCare)}
              virtualCare={Boolean(viewLangData?.virtualCare)}
            />
          ) : (
          <Formik
            enableReinitialize
            initialValues={{
              discountUrlEnglish: state?.english?.url || "",
              discountUrlSpanish: state?.spanish?.url || "",
              phoneNumberEnglish: state?.english?.phone || "",
              phoneNumberSpanish: state?.spanish?.phone || "",
              isVirtualCareEnglish:
                filteredData?.english?.isVirtualCare ??
                state?.english?.isVirtualCare ??
                false,
              isVirtualCareSpanish:
                filteredData?.spanish?.isVirtualCare ??
                state?.spanish?.isVirtualCare ??
                false,
            }}
            validationSchema={
              state?.name === "Telemedicine"
                ? null
                : manageSwitch === false
                ? dpcExtraDiscountValidation
                : dpcExtraDiscountValidationSpanish
            }
            onSubmit={(values, formikBag) => {
              handleFormSubmit(values, formikBag);
            }}
          >
            {({ values, resetForm }) => (
              <Form>
                <div className="switches-container mb-30">
                  <div
                    className="mempro"
                    onClick={() => handleEnglishSwitch(resetForm)}
                  >
                    English
                  </div>
                  <div
                    className="mempro"
                    onClick={() => handleSpanishSwitch(resetForm)}
                  >
                    Spanish
                  </div>
                  <div
                    className={
                      !manageSwitch
                        ? "switch-wrapper"
                        : "switch-wrapper switchside"
                    }
                  >
                    <div className="switch">
                      {!manageSwitch ? <div>English</div> : <div>Spanish</div>}
                    </div>
                  </div>
                </div>
                <div className="redirectionlink d-n one">
                  <div className="sectionpadding d-block mb-30 hoversection btnPosition">
                    <div className="d-flex justify-content-between align-items-center">
                      <p className="mb-0 heedprodct">{state?.name}</p>
                      <Switch
                        className="switches"
                        checked={activeStatus}
                        onChange={handleSwitchChange}
                      />
                    </div>
                    <hr />

                    <div className="login-form">
                      {state?.name !== "Telemedicine" && (
                        <div className="mb-30 d-flex fullwidth gap-20">
                          <div>
                            <Field
                              type="text"
                              placeholder="URL"
                              name={
                                manageSwitch === false
                                  ? "discountUrlEnglish"
                                  : "discountUrlSpanish"
                              }
                              className="form-control w-md-50"
                              onKeyPress={handleKeyPressSpace}
                              autoComplete="Off"
                            />
                            <ErrorMessage
                              name={
                                manageSwitch === false
                                  ? "discountUrlEnglish"
                                  : "discountUrlSpanish"
                              }
                              component="div"
                              className="error text-danger"
                            />
                          </div>

                          <div className="">
                            <Field
                              type="text"
                              name={
                                manageSwitch === false
                                  ? "phoneNumberEnglish"
                                  : "phoneNumberSpanish"
                              }
                              placeholder="Phone Number"
                              className="form-control w-md-50"
                              onKeyPress={handleKeyPressSpace}
                              onKeyDown={(event) => {
                                if (
                                  event.key === "ArrowUp" ||
                                  event.key === "ArrowDown"
                                ) {
                                  event.preventDefault();
                                }
                              }}
                              autoComplete="Off"
                            />
                            <ErrorMessage
                              name={
                                manageSwitch === false
                                  ? "phoneNumberEnglish"
                                  : "phoneNumberSpanish"
                              }
                              component="div"
                              className="error text-danger"
                            />
                          </div>
                        </div>
                      )}
                      {state?.name === "Telemedicine" && (
                        <>
                          {manageSwitch === false ? (
                            <Field type="checkbox" name="isVirtualCareEnglish">
                              {({ field }) => (
                                <Checkbox {...field} checked={field.value}>
                                  Virtual Care (English)
                                </Checkbox>
                              )}
                            </Field>
                          ) : (
                            <Field type="checkbox" name="isVirtualCareSpanish">
                              {({ field }) => (
                                <Checkbox {...field} checked={field.value}>
                                  Virtual Care (Spanish)
                                </Checkbox>
                              )}
                            </Field>
                          )}
                        </>
                      )}
                      {manageSwitch === false ? (
                        <>
                          {!(
                            fileUploaded || filteredData?.english?.fileName
                          ) ? (
                            <Field name="file_upload">
                              {({ field }) => (
                                <Dragger {...props}>
                                  <p className="ant-upload-drag-icon">
                                    <img src={uploadimg} alt="" />
                                  </p>
                                  <p className="ant-upload-text">
                                    <u>Click here</u> or drag & drop to upload
                                    .PDF file
                                  </p>
                                </Dragger>
                              )}
                            </Field>
                          ) : (
                            <div className="ant-upload-list ant-upload-list-text">
                              <span className="ant-upload-list-item-container">
                                <div className="d-flex gap-2 align-items-center file-icon">
                                  <img src={uploadimg} alt="" />
                                  {fileUploaded ||
                                    filteredData?.english?.fileName}
                                </div>
                                <div className="d-flex gap-2">
                                  <a
                                    href={
                                      fileUploadSelector?.data?.data
                                        ?.signedUrl ||
                                      filteredData?.english?.fileUrl
                                    }
                                    target="_blank"
                                  >
                                    <img src={eye} alt="" />
                                  </a>
                                  <div
                                    className="cursorPointer"
                                    onClick={handleDeleteFile}
                                  >
                                    <img src={deleteicon} alt="" />
                                  </div>
                                </div>
                              </span>
                            </div>
                          )}
                        </>
                      ) : (
                        <>
                          {!(
                            spanishFileUpload || filteredData?.spanish?.fileName
                          ) ? (
                            <Field name="file_upload">
                              {({ field }) => (
                                <Dragger {...props}>
                                  <p className="ant-upload-drag-icon">
                                    <img src={uploadimg} alt="" />
                                  </p>
                                  <p className="ant-upload-text">
                                    <u>Click here</u> or drag & drop to upload
                                    .PDF file
                                  </p>
                                </Dragger>
                              )}
                            </Field>
                          ) : (
                            <div className="ant-upload-list ant-upload-list-text">
                              <span className="ant-upload-list-item-container">
                                <div className="d-flex gap-2 align-items-center file-icon">
                                  <img src={uploadimg} alt="" />
                                  {spanishFileUpload ||
                                    filteredData?.spanish?.fileName}
                                </div>
                                <div className="d-flex gap-2">
                                  <a
                                    href={
                                      fileUploadSelector?.data?.data
                                        ?.signedUrl ||
                                      filteredData?.spanish?.fileUrl
                                    }
                                    target="_blank"
                                  >
                                    <img src={eye} alt="" />
                                  </a>
                                  <div
                                    className="cursorPointer"
                                    onClick={handleDeleteFile}
                                  >
                                    <img src={deleteicon} alt="" />
                                  </div>
                                </div>
                              </span>
                            </div>
                          )}
                        </>
                      )}

                      <div className="text-end">
                        <button
                          className="sbg border-0 py3 fw-18 gbo continuebtn disclaimerBtn savebtn"
                          type="submit"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
          )}
        </div>
      </div>
      {!isViewOnly && showVisibilityModal && (
        <VisibilityModal
          showVisibilityModal={showVisibilityModal}
          setShowVisibilityModal={setShowVisibilityModal}
          activeStatus={activeStatus}
          setActiveStatus={setActiveStatus}
        />
      )}
    </>
  );
};

export default EditDpcDiscount;
